export enum RestrictionEnum {
	None,
	Forbidden,
	Deny,
}
